import type { ExportConfig, GeneratedFile, LanguageGenerator } from './types';
import { generateEnv } from './utils';

export const powershellGenerator: LanguageGenerator = {
  id: 'powershell',
  name: 'PowerShell',
  category: 'request-examples',
  color: '#012456',
  generate(config: ExportConfig): GeneratedFile[] {
    const lines: string[] = [
      '# mail_requests.ps1 — generated by Mail Service SDK Export',
      '# Requires: PowerShell 7+ (cross-platform)',
      '',
      `$ServiceUrl = $env:${config.serviceUrlVarName}`,
      '',
    ];

    for (const app of config.apps) {
      lines.push(`# ── ${app.name}`);
      lines.push(`$${app.key}Key = $env:${app.envVarName}`);
      lines.push('');
      for (const t of app.templates) {
        const exampleData = t.schema
          ? t.schema.map((f) => `    ${f.key} = ${f.type === 'number' ? (f.example || '0') : f.type === 'boolean' ? '$true' : `"${f.example || f.key}"`}`).join('\n')
          : '    # no schema';
        lines.push(`# Send: ${t.name}`);
        lines.push(`$body = @{`);
        lines.push(`    template_slug = "${t.slug}"`);
        lines.push(`    recipient     = "user@example.com"`);
        lines.push(`    data          = @{`);
        lines.push(exampleData.split('\n').map((l) => '    ' + l).join('\n'));
        lines.push(`    }`);
        lines.push(`}`);
        lines.push(`Invoke-RestMethod -Method Post \\`);
        lines.push(`  -Uri "$ServiceUrl/v1/send" \\`);
        lines.push(`  -Headers @{ "Content-Type" = "application/json"; "X-API-KEY" = "$${app.key}Key" } \\`);
        lines.push(`  -Body ($body | ConvertTo-Json -Depth 5)`);
        lines.push('');
      }
    }

    return [
      { filename: 'mail_requests.ps1', content: lines.join('\n'), syntax: 'powershell' },
      { filename: '.env', content: generateEnv(config), syntax: 'shell' },
    ];
  },
};
